import { useEffect, useState } from 'react';

import { findPath } from '@libs/NwUtils';

import { forceReloadContact } from '@hooks/API/Contact/UseContact';
import { forceReloadContactPlaylists } from '@hooks/API/Contact/UseContactPlaylists';
import { forceReloadPlaylist, forceReloadPlaylistInfo } from '@hooks/API/UsePlaylist';
import { useRemovePlayList } from '@hooks/API/UseWebsites';

const formatPlaylistPublishedWebsites = (book, websiteData = []) => {
    if (!book?.Divisions?.length) {
        return [];
    }

    return book.Divisions.map((item) => ({
        websiteName: item.WebsiteName ? item.WebsiteName.toUpperCase() : item.WebsiteCode?.toUpperCase() || '',
        path: websiteData.length
            ? findPath(websiteData, item.WebsiteCode, item.DivisionCode, '', true) || item.DivisionCode || ''
            : item.DivisionCode || '',
        role: item.Role,
        websiteCode: item.WebsiteCode,
        divisionCode: item.DivisionCode,
        playlistID: book.ID,
        contactID: book.ContactID,
    }));
};

const isSamePublishedWebsite = (left, right) =>
    left.websiteCode === right.websiteCode &&
    left.divisionCode === right.divisionCode &&
    Number(left.playlistID) === Number(right.playlistID);

export function usePlaylistPublishedWebsites({ book, websiteData = [], onAfterUnlink }) {
    const { mutateAsync: onRemovePlayList } = useRemovePlayList();
    const [loading, setLoading] = useState(false);
    const [linkedSections, setLinkedSections] = useState(() => formatPlaylistPublishedWebsites(book, websiteData));

    useEffect(() => {
        setLinkedSections(formatPlaylistPublishedWebsites(book, websiteData));
    }, [book, websiteData]);

    const unlinkPublication = async (item) => {
        setLoading(true);
        try {
            await onRemovePlayList({
                WebsiteCode: item.websiteCode,
                PlaylistID: item.playlistID,
                DivisionCode: item.divisionCode,
            });

            setLinkedSections((currentLinkedSections) =>
                currentLinkedSections.filter((linkedItem) => !isSamePublishedWebsite(linkedItem, item))
            );

            if (item.contactID) {
                forceReloadContact(item.contactID);
                forceReloadContactPlaylists(item.contactID);
            }
            if (item.playlistID) {
                forceReloadPlaylist(item.playlistID);
                forceReloadPlaylistInfo(item.playlistID);
            }

            if (onAfterUnlink) {
                onAfterUnlink(item);
            }

            return true;
        } catch (error) {
            console.error('error unlinking playlist publication', error);
            return false;
        } finally {
            setLoading(false);
        }
    };

    return {
        linkedSections,
        loading,
        unlinkPublication,
    };
}
